module.exports = __webpack_public_path__ + "static/media/freeboard.0ed1d885.png";